export const getValidNextPath = (nextPath: string): string => {
  let decodedPath;
  try {
    // Decode the URL-encoded string
    decodedPath = decodeURIComponent(nextPath);
  } catch (error: any) {
    return '/';
  }
  // check if it's a relative path
  return decodedPath.startsWith('/') ? nextPath : '/';
};
